import {
  closeDrawers,
  openBookSecurityReviewDrawer,
  openChangeAccountDetailsDrawer,
  openNewContactDrawer,
  openNewTicketDrawer,
  openRequestQuoteDrawer
} from '~/actions/drawerActions'

import { FaBuilding, FaFileInvoiceDollar, FaShieldAlt, FaUserPlus } from 'react-icons/fa'
import { IoTicket } from 'react-icons/io5'
import { useDispatch } from 'react-redux'

import { Tile, TileHeader, TileListContent, TileListItem } from '../Tile'

const QuickActionsTile = () => {
  const dispatch = useDispatch()

  const actions = [
    {
      title: 'New Ticket',
      icon: <IoTicket className="h-6 w-6 text-th-warning" />,
      onClick: () => {
        dispatch(closeDrawers())
        dispatch(openNewTicketDrawer())
      }
    },
    {
      title: 'New Contact',
      icon: <FaUserPlus className="h-6 w-6 text-th-primary" />,
      onClick: () => {
        dispatch(closeDrawers())
        dispatch(openNewContactDrawer())
      }
    },
    {
      title: 'Request Quote',
      icon: <FaFileInvoiceDollar className="h-6 w-6 text-th-success" />,
      onClick: () => {
        dispatch(closeDrawers())
        dispatch(openRequestQuoteDrawer())
      }
    },
    {
      title: 'Account Details Change',
      icon: <FaBuilding className="h-6 w-6 text-th-info" />,
      onClick: () => {
        dispatch(closeDrawers())
        dispatch(openChangeAccountDetailsDrawer())
      }
    },
    {
      title: 'Book Security Review',
      icon: <FaShieldAlt className="h-6 w-6 text-th-error" />,
      onClick: () => {
        dispatch(closeDrawers())
        dispatch(openBookSecurityReviewDrawer('M365'))
      }
    }
  ]

  return (
    <Tile>
      <TileHeader>
        <TileHeader.Title>Quick Actions</TileHeader.Title>
        <TileHeader.Subtitle>Common Tasks & Requests</TileHeader.Subtitle>
      </TileHeader>
      <TileListContent limit={actions.length}>
        {actions.map((action) => (
          <TileListItem key={action.title} onMouseDown={action.onClick}>
            <div className="flex items-center gap-3">
              {action.icon}
              <span className="text-sm font-medium">{action.title}</span>
            </div>
          </TileListItem>
        ))}
      </TileListContent>
    </Tile>
  )
}

export default QuickActionsTile
